import React, { Component } from "react";
import { isNullOrUndefined } from "../HWLibrary/HWUtils";
import "./InitialFormStyleSheet.css";

class InitialFormHeader extends Component {
  onClose = () => {
    // this.props.actions && this.props.actions.onHideChatWindow && this.props.actions.onHideChatWindow();
    this.props.actions.onStartUpClick();
  };

  headerStyle = () => {
    return {
      background:
        this.props.config.designDetails.headerBackgroundImage !== undefined &&
        this.props.config.designDetails.headerBackgroundImage !== ""
          ? "url(" + this.props.config.designDetails.headerBackgroundImage + ")"
          : this.props.config.designDetails.headerTopColor,
    };
  };
  subHeaderStyle = () => {
    return {
      color: this.props.config.designDetails.subHeaderFontColor,
      fontFamily: this.props.config.designDetails.subHeaderFont,
      fontSize: this.props.config.designDetails.subHeaderFontSize,
    };
  };

  headerIconStyle = () => {
    return {
      fill: isNullOrUndefined(this.props.config.designDetails.headerIconColor)
        ? "#1f175c"
        : this.props.config.designDetails.headerIconColor,
    };
  };
  headerTextStyle = () => {
    return {
      color: this.props.config.designDetails.headerFontColor,
      fontFamily: this.props.config.designDetails.headerFont,
      fontSize: this.props.config.designDetails.headerFontSize,
      // background: this.props.config.designDetails.headerBackgroundImage !== undefined && this.props.config.designDetails.headerBackgroundImage !== ""?("url("+this.props.config.designDetails.headerBackgroundImage+")"):this.props.config.designDetails.headerTopColor,
    };
  };

  render() {
    return (
      <div className="s360-initial-form-header" style={this.headerStyle()}>
        <div className="s360-initial-form-header-message">
          <div
            className="s360-initial-form-header-salutation-message"
            style={this.headerTextStyle()}
          >
            <h4 style={{ fontFamily: "poppins", fontWeight: "bold" }}>
              {this.props.config.configDetails.brandMessage.toString()}
            </h4>

            <div className="s360-default-header-icon" onClick={this.onClose}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13.624"
                height="53"
                viewBox="0 0 13.624 8.209"
              >
                <path
                  id="down-arrow"
                  d="M2370.983,5063.169a1,1,0,0,1-.73-.316l-5.812-6.209a1,1,0,0,1,1.46-1.367l5.082,5.429,5.082-5.429a1,1,0,0,1,1.46,1.367l-5.812,6.209A1,1,0,0,1,2370.983,5063.169Z"
                  transform="translate(-2364.171 -5054.96)"
                  style={this.headerIconStyle()}
                />
              </svg>
            </div>
          </div>
        </div>

        <div
          className="s360-initial-form-header-welcome-message"
          style={this.headerTextStyle()}
        >
          {this.props.config.configDetails.brandWelcomeMessage}
        </div>
        <div
          className="s360-initial-form-sub-header-message"
          style={this.subHeaderStyle()}
        >
          {this.props.config.configDetails.brandSubMessage}
        </div>
      </div>
    );
  }
}

export default InitialFormHeader;
